/**
 * ProjectName: MindMap
 * Created by tony on 2026/3/7
 * Copyright(c) 2026 mindyushu.com
 */

import HttpServerConfig from "../../../common/HttpServerConfig";
import { md5 } from "../../../common/netWork/base";
import Util from "../../../utils/Util";
import LoadLocalXJMind from "../../../viewmodel/core/tools/mapfile/LoadLocalXJMind";
import MindMe from "../../../viewmodel/facade/MindMe";

class StorageManager {
    constructor(appPath = "") {
        this.isElectron = true;
        this.HistortFolderName = "/xjmind"
        this.fileCacheName = "/xjcache"
        this.FileSeparator = "/"
        this.appPath = LoadLocalXJMind.appPath;
        this.rootPath = "";
        this.setSeparator()
    }

    get() {
        return this;
    }

    setSeparator() {
        let platform = navigator.platform.toLowerCase()
        let isWindows = platform.indexOf('win32') > -1 || platform.indexOf('win64') > -1
        if (isWindows) {
            this.FileSeparator = "\\"
            this.HistortFolderName = this.HistortFolderName.replaceAll("/", this.FileSeparator)
            this.fileCacheName = this.fileCacheName.replaceAll("/", this.FileSeparator)
        } else {
            this.FileSeparator = "/"
        }
        this.rootPath = this.appPath + this.HistortFolderName
    }

    saveLogin() {

    }

    getMindAndIcloud() {
        return new Array();
    }

    createDeletedMap(name, imageUrl, subtitle, mindType, nodes) {
        return 1;
    }

    getIsAgreePrivacy() {
        return 1;
    }

    saveUsername(name) {
    }

    getUsername() {
        return 1;
    }

    saveAppVersion(version) {
    }

    getAppVersion() {
        return 1;
    }

    createMindPreview(name, imageUrl, detailsId, mindType) {
        return 1;
    }

    getMyMindList() {
        return 1;
    }

    saveMyMindImage(id, imageUrl) {
    }

    saveMyMindName(id, name) {
    }

    saveMyMindSubtitle(id, subtitle) {
    }

    removeMind(id) {
    }

    createMindDetails(name) {
        return -1
        //return this.sqlite.createMindDetails(name);
    }

    saveMindNodes(id, nodes) {
        // this.sqlite.saveMindNodes(id, nodes);
    }

    saveMindDetailsLayout(id, layout) {
        // this.sqlite.saveMindDetailsLayout(id, layout);
    }

    getMindDetails(id) {
        return 1;
        // return this.sqlite.getMindDetails(id);
    }

    getPreviewMindById(id) {
        return 1;
    }

    saveUpgradeExpireTime(expireTime) {
    }

    getUpgradeExpireTime() {
        return -1;
    }

    saveUpgradeType(type) {
    }

    getUpgradeType() {
        return 1;
    }

    getAllImageKey() {
        return 1;
    }

    saveIsOpenHelpPanel(value) {
    }

    getIsOpanHelpPanel() {
        return 1;
    }

    createMindFile(name, parentId, type) {
        return 1;
        // return this.sqlite.createMindFile(name, parentId, type);
    }

    saveMindFileName(id, name) {
        // this.sqlite.saveMindFileName(id, name);
    }

    saveMindFileChilds(id, childs) {
        // this.sqlite.saveMindFileChilds(id, childs);
    }

    saveMindFileParent(id, parentId) {
        // this.sqlite.saveMindFileParent(id, parentId);
    }

    saveMindFileType(id, type) {
        // this.sqlite.saveMindFileType(id, type);
    }

    readMindFileDescribeById(id) {
        return 1;
        // return this.sqlite.readMindFileDescribeById(id);
    }

    getMindFilelist() {
        return 1;
        // return this.sqlite.getMindFilelist();
    }

    removeMindFile(id) {
        // this.sqlite.removeMindFile(id);
    }

    createIcloud(mindId, icloudId) {
        return 1;
        // return this.sqlite.createIcloud(mindId, icloudId);
    }

    remove(id) {
        // this.sqlite.remove(id);
    }

    getIcloudIdlist() {
        return 1;
        // return new Array();//this.sqlite.getIcloudIdlist()
    }

    saveEnterMindMapTimes() {
        // this.storageHolder.saveEnterMindMapTimes();
    }

    getEnterMindMapTimes() {
        return 1;
        // return this.storageHolder.getEnterMindMapTimes();
    }

    saveDisplayAppCommentTime(expireTime) {
        // this.storageHolder.saveDisplayAppCommentTime(expireTime);
    }

    getDisplayAppCommentTime() {
        return 1;
        // return this.storageHolder.getDisplayAppCommentTime();
    }

    saveDisplayAppCommentStatus(status) {
        // this.storageHolder.saveDisplayAppCommentStatus(status.getValue());
    }

    getDisplayAppCommentStatus() {
        // let status = this.storageHolder.getDisplayAppCommentStatus();
        return 1;
        // return AppCommentStatus.from(this.status);
    }

    saveClickPreviewImage(value) {
        // this.storageHolder.saveClickPreviewImage(value);
    }

    getClickPreviewImage() {
        return 1;
        // return this.storageHolder.getClickPreviewImage();
    }

    createDeletedMap(name, imageUrl, subtitle, mindType, nodes) {
        return 1;
        // return this.sqlite.createDeletedMap(name, imageUrl, subtitle, mindType, nodes);
    }

    removeDeletedMap(id) {
        // this.sqlite.removeDeletedMap(id);
    }

    getDeletedMapList() {
        return 1;
        // return this.sqlite.getDeletedMapList();
    }

    getDeletedMapById(id) {
        return 1;
        // return this.sqlite.getDeletedMapById(id);
    }

    createCustomStyle(imageUrl, nodes) {
        return 1;
        // return this.sqlite.createCustomStyle(imageUrl, nodes);
    }

    removeCustomStyle(id) {
        // this.sqlite.removeCustomStyle(id);
    }

    getCustomStyleList() {
        return 1;
        // return this.sqlite.getCustomStyleList();
    }

    getCustomStyleNodesById(id) {
        return 1;
        // return this.sqlite.getCustomStyleNodesById(id);
    }

    saveHistoryColors(value) {
        // this.storageHolder.saveHistoryColors(value);
    }

    getHistoryColors() {
        return 1;
        // return this.storageHolder.getHistoryColors();
    }

    saveConnectLineDragStatus() {
        // this.storageHolder.saveConnectLineDragStatus();
    }

    getConnectLineDragStatus() {
        return 1;
        // return this.storageHolder.getConnectLineDragStatus();
    }

    saveInstallTime() {
        // this.sqlite.saveInstallTime();
    }

    getInstallTime() {
        return 1;
        // return this.sqlite.getInstallTime();
    }

    saveDevideUUid(value) {
        // this.storageHolder.saveDevideUUid(value);
    }

    getDevideUUid() {
        return 1;
        // return this.storageHolder.getDevideUUid();
    }

    getUser() {
        return 1;
        // return this.sqlite.getUser();
    }

    creatUser(userId, name, creatTime, memeberType,
        memberExpire, userLevel, authorization) {
        // this.sqlite.creatUser(userId, name, creatTime, memeberType, memberExpire, userLevel, authorization);
    }

    saveUserName(name) {
        // this.sqlite.saveUserName(name);
    }

    saveMemberExpire(memberExpire) {
        // this.sqlite.saveMemberExpire(memberExpire);
    }

    saveMemberType(memeberType) {
        // this.sqlite.saveMemberType(memeberType);
    }

    saveUserLevel(userLevel) {
        // this.sqlite.saveUserLevel(userLevel);
    }

    saveAuthorization(authorization) {
        // this.sqlite.saveAuthorization(authorization);
    }

    saveServerLocalTimeDifference(time) {
        // this.sqlite.saveServerLocalTimeDifference(time);
    }

    getServerLocalTimeDifference() {
        return 1;
        // return this.sqlite.getServerLocalTimeDifference();
    }

    savePayPrice(value) {
        // this.sqlite.savePayPrice(value);
    }

    getPayPrice() {
        return 1;
        // return this.sqlite.getPayPrice();
    }

    savePayChannels(value) {
        // this.sqlite.savePayChannels(value);
    }

    getPayChannels() {
        return 1;
        // return this.sqlite.getPayChannels();
    }

    saveCheckUpdataTime(value) {
        // this.storageHolder.saveCheckUpdataTime(value + "");
    }

    getCheckUpdataTime() {
        return -1;
    }

    getLocalCacheFilePath(fileName) {
        return this.getLocalCachePath() + this.FileSeparator + fileName
    }

    getFileLoadPath(url, isAddPrefix = true) {
        if (url == null && url.length == 0) {
            return ""
        }
        if (url.indexOf("xjcache") > -1) {
            let newUrl = HttpServerConfig.removeUrlPrefix(url)
            let realPath = this.getLocalCachePath() + this.FileSeparator + md5(newUrl) + "." + Util.getUrlType(newUrl)            
            var fs = window.require('fs');
            let e = fs.existsSync(realPath)
            if (!e) {
                e = fs.existsSync(url)
                if (e) {
                    realPath = url
                }
            }
            if (e) {
                if (isAddPrefix) {
                    return HttpServerConfig.getLocalPathPrefix(realPath, this.appPath)
                } else {
                    return path
                }
            }
        }
        return url;
    }

    getLocalCachePath() {
        this.createFolder(this.appPath + this.fileCacheName);
        return this.appPath + this.fileCacheName
    }

    saveRecentEditHistoryContent(content) {
        // let fileName = "recentEditHistoryContent.json"
        // if (MindMe.isLogin()) {

        // }
        // let that = this
        // return new Promise(async resolve => {
        //     try {
        //         this.saveLocalContent(this.rootPath, fileName, content).then((data) => {
        //             resolve(data)
        //         })
        //     } catch (error) {
        //         console.log("save file error: ", error);
        //         resolve(false)
        //     }            
        // });
    }

    getRecentEditHistoryContent() {
        let fileName = "recentEditHistoryContent.json"
        let that = this
        this.loadJson(this.rootPath + this.FileSeparator + fileName).then((data) => {
            resolve(data)
        })
    }

    deleteFile(filePath) {
        var that = this
        return new Promise(async resolve => {
            try {      
                console.log("deleteFile file: ", filePath);              
                const result = await ipcRenderer.invoke('delete-file', filePath)
                let data = {success: result.success, message: result.message}          
                resolve(data)
            } catch (error) {
                console.log("deleteFile error: ", error);                
                resolve({success: false, message: error.message})
            }
        });        
    }

    existsLocalFile(path) {
        var fs = window.require('fs');
        let e = fs.existsSync(path)
        return e
    }

    saveLocalContent(path, name, content) {
        let that = this;
        return new Promise(resolve => {
            if (path == null) {
                resolve(false)
                return 
            }
            var fs = window.require('fs');            
            if (name == null || name.length == 0) {
                fs.writeFile(path, content, function (err) {
                    if (err != null) {
                        resolve(false)
                    } else {
                        resolve(true)
                    }
                });
            } else {
                this.createFolder(path);
                fs.writeFile(path + that.FileSeparator + name, content, function (err) {
                    if (err != null) {
                        resolve(false)
                    } else {
                        resolve(true)
                    }
                });
            }
        })
    }

    loadJson(jsonpath) {
        let that = this
        return new Promise(async resolve => {
            try {
                const xhr = new XMLHttpRequest();
                xhr.open('GET', HttpServerConfig.getLocalPathPrefix(jsonpath, that.appPath), true);
                xhr.responseType = 'blob';
                xhr.onload = () => {
                    if (xhr.status === 200) {
                        var fr = new FileReader();
                        fr.readAsText(xhr.response, "utf-8");
                        fr.addEventListener("loadend",(e) => {
                            var json = e.target.result;
                            resolve(json)
                        },false);
                    } else {
                        console.log("xhr.response xhr.status - ", xhr.status);
                        resolve("")
                    }
                };
                
                
                xhr.onerror = (error) => {
                    console.log("xhr.response error - ", error);
                    resolve("")
                };
                xhr.send();
            } catch (error) {
                console.log("loadJson error: ", error);
                resolve("")
            }
            
        });
    }

    createFolder(dirpath, dirname) {
        var fs = window.require('fs');
        var path = window.require('path');
        if (typeof dirname === "undefined") {
          if (fs.existsSync(dirpath)) {
          } else {
            this.createFolder(dirpath, path.dirname(dirpath));
          }
        } else {
          if (dirname !== path.dirname(dirpath)) {
            this.createFolder(dirpath);
            return;
          }
          if (fs.existsSync(dirname)) {
            fs.mkdirSync(dirpath,{recursive:true})
          } else {
            this.createFolder(dirname, path.dirname(dirname));
            fs.mkdirSync(dirpath,{recursive:true});
          }
        }
    }
}
export default StorageManager
